const invoice = {
	name: 'Rechnung | Rechnungen',
	fields: {
		invoice_number: 'Rechnungsnr.',
		invoice_date: 'Datum',
		invoice_amount: 'Betrag',
		authorized_date: 'Freigegeben am',
		authorized_amount: 'Freigegeben',
		due_date: 'Fällig am',
		booking_text: 'Buchungstext',
		accounting_year: {
			year: 'Jahr',
		},
		building_id: 'Liegenschaft',
		comments_count: 'Kommentare',
	},
}

export default invoice
